import { FC, useState } from "react";
import { useAuth } from "../auth/authContext";

export const Home: FC = () => {
  const { emailVerified, sendEmailVerification } = useAuth();
  const [emailSent, setEmailSent] = useState(false);

  const sendEmail = () => {
    sendEmailVerification();
    setEmailSent(true);
  };

  return (
    <div>
      {emailVerified ? (
        <Dashboard />
      ) : (
        <>
          {emailSent ? (
            <div className="alert alert-info mt-3">
              <div className="mt-3">
                <p>
                  Email sent. Check your inbox and click on the link to verify
                  your account.
                </p>
              </div>
            </div>
          ) : (
            <div className="alert alert-info mt-3">
              <p>
                Just one more step. We still need to verify your email address.
              </p>
              <div className="mt-3 text-right">
                <button className="btn btn-primary" onClick={sendEmail}>
                  Send verification email
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

const Dashboard: FC = () => {
  return (
    <div>
      <h4>Dashboard</h4>
      <p>Welcome to SharePark.</p>
    </div>
  );
};
